import script from "./StepOne.vue?vue&type=script&setup=true&lang=js"
export * from "./StepOne.vue?vue&type=script&setup=true&lang=js"

import "./StepOne.vue?vue&type=style&index=0&id=52d5c556&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52d5c556"]])

export default __exports__